import Vue from 'vue'
import Router from 'vue-router'
import AuthenticationConfig from '@/components/AuthenticationConfig'
import EmailConfig from '@/components/EmailConfig'
import SyslogServer from '@/components/SyslogServer'
import TimeConfig from '@/components/TimeConfig'
import GeneralScript from '@/components/GeneralScript'
import Login from '@/components/Login'
import Dashboard from '@/components/Dashboard'
import Network from '@/components/Network'
import InitMode from '@/components/InitMode'
import InitAgung from '@/components/InitAgung'
import OsUpdate from '@/components/OsUpdate'
import FullPadminActivityLog from '@/components/FullPadminActivityLog'
import OwnPadminActivityLog from '@/components/OwnPadminActivityLog'
import RemoteLogin from '@/components/RemoteLogin'
import ZabbixConfig from '@/components/ZabbixConfig'
import ImportConfig from '@/components/ImportConfig'
import ExportConfig from '@/components/ExportConfig'
import UserManagement from '@/components/UserManagement'
import PmslCommandDemo from '@/components/PmslCommandDemo'
import VpnConnection from '@/components/VpnConnection'
import IpFilterConfig from '@/components/IpFilterConfig'
import SessionManagementConfig from '@/components/SessionManagementConfig'
import LicenseConfig from '@/components/LicenseConfig'
import DiskSpaceMonitoring from '@/components/DiskSpaceMonitoring'
import FilteredActivityLog from '@/components/FilteredActivityLog'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard
    },

    {
      path: '/login',
      name: 'Login',
      component: Login
    },

    {
      path: '/init/mode',
      name: 'InitMode',
      component: InitMode
    },

    {
      path: '/init/agung',
      name: 'InitAgung',
      component: InitAgung
    },

    {
      path: '/general_script/config/authentication',
      name: 'AuthenticationConfig',
      component: AuthenticationConfig
    },

    {
      path: '/general_script/config/email',
      name: 'EmailConfig',
      component: EmailConfig
    },

    {
      path: '/general_script/config/user_management',
      name: 'UserManagement',
      component: UserManagement
    },


    {
      path: '/general_script/config/syslog_server',
      name: 'SyslogServer',
      component: SyslogServer
    },

    {
      path: '/general_script/config/time',
      name: 'TimeConfig',
      component: TimeConfig
    },

    {
      path: '/general_script/config/zabbix',
      name: 'ZabbixConfig',
      component: ZabbixConfig
    },

    {
      path: '/general_script/security/remote_login',
      name: 'RemoteLogin',
      component: RemoteLogin
    },

    {
      path: '/general_script/config/network',
      name: 'Network',
      component: Network
    },

    {
      path: '/general_script/update/os_update',
      name: 'OsUpdate',
      component: OsUpdate
    },

    {
      path: '/general_script/data/export',
      name: 'ExportConfig',
      component: ExportConfig
    },

    {
      path: '/general_script/data/import',
      name: 'ImportConfig',
      component: ImportConfig
    },

    {
      path: '/general_script/logs/own_padmin_activity',
      name: 'OwnPadminActivityLog',
      component: OwnPadminActivityLog
    },

    {
      path: '/general_script/logs/full_padmin_activity',
      name: 'FullPadminActivityLog',
      component: FullPadminActivityLog
    },

    {
      path: '/general_script/config/vpn_connection',
      name: 'VpnConnection',
      component: VpnConnection
    },

    {
      path: '/general_script/security/ip_filter',
      name: 'IpFilterConfig',
      component: IpFilterConfig
    },

    {
      path: '/general_script/config/session_management',
      name: 'SessionManagementConfig',
      component: SessionManagementConfig
    },

    {
      path: '/general_script/config/license',
      name: 'LicenseConfig',
      component: LicenseConfig
    },

    {
      path: '/general_script/status/disk_space_monitoring',
      name: 'DiskSpaceMonitoring',
      component: DiskSpaceMonitoring
    },

    {
      path: '/general_script/logs/filtered_activity',
      name: 'FilteredActivityLog',
      component: FilteredActivityLog
    },

    {
      path: '/general_script/:menu/:script_name',
      name: 'GeneralScript',
      component: GeneralScript
    },

    {
      path: '/pmsl_command_demo',
      name: 'PmslCommandDemo',
      component: PmslCommandDemo
    }
  ]
})

export default router
